import { useEffect, useState } from "react";
import { subscribe, promptInstall } from "@shared/src/utils/pwa-manager";

type PWAState = {
  isInstallable: boolean;
  isInstalled: boolean;
  deferredPrompt: any | null;
};

export const usePWA = () => {
  const [state, setState] = useState<PWAState>({
    isInstallable: false,
    isInstalled: false,
    deferredPrompt: null,
  });

  useEffect(() => {
    // Don't subscribe in embedded browsers
    if (typeof window !== "undefined" && window.self !== window.top) {
      console.log("PWA Hook disabled in embedded browser");
      setState({ isInstallable: false, isInstalled: false, deferredPrompt: null });
      return;
    }

    console.log("==== PWA Hook Subscribing ====");
    const unsubscribe = subscribe(setState);

    return () => {
      console.log("==== PWA Hook Unsubscribing ====");
      unsubscribe();
    };
  }, []);

  return {
    isInstallable: state.isInstallable,
    isInstalled: state.isInstalled,
    install: async () => {
      // Add additional checks before installation
      if (typeof window !== "undefined" && window.self !== window.top) {
        console.log("Installation blocked in embedded browser");
        return "unavailable";
      }
      return promptInstall();
    },
  };
};
